// extracted by mini-css-extract-plugin
export default {"sectionReviews":"hnxba","empty":"rfBVG","wrapperListReviews":"MWLxz ZdH1P","listReviews":"DY655","emptyReviewWrapper":"Q4AcL ZdH1P"};